import { defineRecipe } from "@chakra-ui/react";

// Button recipe for different variants and styles
export const buttonRecipe = defineRecipe({
  className: 'button',
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 'md',
    fontWeight: 'bold',
    fontFamily: 'body',
    cursor: 'pointer',
    transition: 'background 0.2s ease-in-out, color 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    _focusVisible: {
      // Using a real token for the focus outline
      outline: '2px solid {colors.blue.primary}',
      outlineOffset: '2px',
    }
  },

  variants: {
    visual: {
      // The Primary (Blue) Button
      primary: {
        bg: 'button.primary.background',
        color: 'button.primary.text',
        _hover: {
          bg: 'button.primary.hoverBackground'
        }
      },
      // The Secondary (Gray) Button
      secondary: {
        bg: 'button.secondary.background',
        color: 'button.secondary.text',
        _hover: {
          bg: 'button.secondary.hoverBackground'
        }
      },
      // The CTA (Gradient) Button - Renamed from 'accent' for clarity
      cta: {
        background: 'button.cta.gradient',
        color: 'button.cta.text',
        _hover: {
          // A subtle shadow effect on hover for gradients
          boxShadow: 'lg'
        }
      },

      // --- Contextual Buttons ---
      destructive: {
        // For dangerous actions like deleting data
        bg: 'red.500', // We will add this token next
        color: 'white',
        _hover: {
          bg: 'red.600'
        }
      },
      ghost: {
        // A transparent button for subtle actions
        bg: 'transparent',
        color: 'text.primary',
        _hover: {
          bg: { base: 'gray.200', _dark: 'black.300' }
        }
      },
    },
    size: {
      md: {
        fontSize: 'md',
        px: '6', // Assuming '6' is '1.5rem' in your spacing tokens
        h: '12'  // Assuming '12' is '3rem' in your spacing tokens
      },
      sm: {
        fontSize: 'sm',
        px: '4', // Assuming '4' is '1rem'
        h: '10'  // Assuming '10' is '2.5rem'
      }
    }
  },

  defaultVariants: {
    visual: 'primary',
    size: 'md'
  }
});
